import React from 'react';
import { DefaultFooter } from '@/src/components/root/Footer/DefaultFooter/DefaultFooter';
import { EventFooter } from '@/src/components/root/Footer/EventFooter/EventFooter';
import { useResize } from '@/src/hooks/useResize';
import { useJamLeaderboard } from '@/src/store/jam-leaderboard.context';
import {
  jamChallengesRegex,
  jamChallengeTaskRegex,
  jamChatRegex,
  jamEventLeaderboardRegex,
} from '@/src/utils/myjam.utils';
import { useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import styles from './Footer.module.scss';

const FooterContent: React.FC = () => {
  const { pathname } = useLocation();
  if (jamChallengesRegex.test(pathname) || jamChallengeTaskRegex.test(pathname) || jamChatRegex.test(pathname)) {
    return <EventFooter />;
  }
  return <DefaultFooter />;
};

export const Footer: React.FC = () => {
  const { mouseMoved } = useJamLeaderboard();
  const { pathname } = useLocation();
  const footerRef = useRef<HTMLElement>();
  const paddingRef = useRef<HTMLElement>();

  const updatePaddingHeight = () => {
    if (!paddingRef.current) {
      return;
    }

    paddingRef.current.style.height = `${footerRef.current?.clientHeight}px`;
  };

  useLayoutEffect(() => updatePaddingHeight());
  useResize(() => updatePaddingHeight());

  // Leaderboard page has its own dedicated footer
  if (jamEventLeaderboardRegex.test(pathname)) {
    return null;
  }

  if (!mouseMoved && !footerRef.current?.matches(':hover')) {
    return null;
  }

  return (
    <>
      <div ref={paddingRef as any} data-testid="footer-padding" />
      <footer ref={footerRef as any} id={styles.footer}>
        <FooterContent />
      </footer>
    </>
  );
};
